import './index.scss'
import './audio.js'
import { getPlatform } from 'src/frontend-lib/tools/getPlatform'

import { FixHeader, axios, track } from 'cm'
import config from './config'
import md5 from 'md5'
import VipLock from 'src/public-resource/components/VipLock'

let fm_id = window.location.pathname.slice(1).split('/')[2] || ''

class programShare {
  constructor() {
    this.data = {
      playStatus: true
    }
    this.init()
  }
  init() {
    // setHeader(config.headerConfig);
    new FixHeader(config.headerConfig)
    this.eventInit()
    // window.yxl.stat.send({
    //   name: '首页-「主页」访问',
    // });
    // 神策埋点-节目详情页-页面访问
    track.trackPageView('m_FM_detail_view', {
      fm_id: fm_id
    })
    var downloadBtn = document.getElementById('downloadBtn')
    downloadBtn.addEventListener('click', function() {
      // 神策埋点-节目详情页-点击操作按钮
      track.trackEvent('m_FM_detail_clickoperationbutton', {
        button_name: '下载app',
        fm_id: fm_id
      })
      window.location.href = 'https://d.xinli001.cc/fm/dl'
    })
    let UAobj = getPlatform()
    var collection = document.getElementsByClassName('collection')[0]
    if (UAobj.isAndroid) {
      collection.innerHTML =
        '<i class="yxl-font yxl-font-Notdownloaded"></i>下载节目'
    }
    var toastDivObj = document.getElementsByClassName('toast-wrap')[0]
    var toastObj = document.getElementsByClassName('toast')[0]
    var collectionBtn = document.getElementsByClassName('collection')[0]
    collectionBtn.onclick = function() {
      // 神策埋点-节目详情页-点击操作按钮
      track.trackEvent('m_FM_detail_clickoperationbutton', {
        button_name: '收藏电台',
        fm_id: fm_id
      })
      toastObj.innerHTML = '请下载APP'
      toastDivObj.style.display = 'flex'
      var collectionTimer = setTimeout(function() {
        toastDivObj.style.display = 'none'
        window.location.href = 'https://d.xinli001.cc/fm/dl'
        clearTimeout(collectionTimer)
      }, 2000)
    }
    var FMdecritionb = document.getElementsByClassName('FM-decrition-b')[0]
      .children[0]
    FMdecritionb.addEventListener('click', function() {
      // 神策埋点-节目详情页-点击操作按钮
      track.trackEvent('m_FM_detail_clickoperationbutton', {
        button_name: '查看主播',
        fm_id: fm_id
      })
    })
  }
  zhugeEvent() {}
  headerEvent() {}
  audioEvent() {
    var that = this
    window.onload = function() {
      var runTimer
      var audioDivObj = document.getElementsByClassName('audio-div')[0]
      var audioObj = audioDivObj.getElementsByTagName('audio')[0]
      if ($('.FM-decrition-t p').width() > $('.FM-decrition-t').width()) {
        $('.FM-decrition-t').append($('.FM-decrition-t').html())
        var Pwidth = parseInt($('.FM-decrition-t p').width())
        $('.FM-decrition-t p')
          .eq(1)
          .css('left', Pwidth + 60)
        var runTitleFn = function() {
          $('.FM-decrition-t p').each(function(index, e) {
            var rigthNum = parseFloat($(e).css('left'))
            if (index == 1 && rigthNum == 0) {
              $('.FM-decrition-t p')
                .eq(1)
                .css('left', Pwidth + 60 + 'px')
              $('.FM-decrition-t p')
                .eq(0)
                .css('left', '0')
              clearInterval(runTimer)
              clearTimeout(timerout)
              var timerout = setTimeout(function() {
                runTimer = setInterval(runTitleFn, 20)
              }, 1000)
              return false
            } else {
              var newValue = rigthNum - 1
              $(e).css('left', newValue)
            }
          })
        }
        var runtimerout = setTimeout(function() {
          runTimer = setInterval(runTitleFn, 20)
          clearTimeout(runtimerout)
        }, 3000)
      }
      if (audioObj.getAttribute('src') !== '') {
        var setConfig = {
          song: [
            {
              title: '笑脸',
              src: audioObj.getAttribute('src')
            }
          ],
          error: function(meg) {
            var toastDivObj = document.getElementsByClassName('toast-wrap')[0]
            var toastObj = document.getElementsByClassName('toast')[0]
            var playIconObj = document.getElementsByClassName('playIcon')[0]
            var animationDivObj = document.getElementsByClassName(
              'animation-div'
            )[0]
            animationDivObj.style.display = 'none'
            playIconObj.style.display = 'block'
            toastObj.innerHTML = meg.meg
            toastDivObj.style.display = 'flex'
            var noneTimer = setTimeout(function() {
              that.data.playStatus = false
              toastDivObj.style.display = 'none'
              clearTimeout(noneTimer)
            }, 1000)
          }
        }
        var audioFn = audioPlay(setConfig)
        if (audioFn) {
          console.log(123)
          // 开始加载音频,true为播放,false不播放
          audioFn.loadFile(false)
        }
        var audioId = null
        if (window.location.href.indexOf('fm/share/') >= 0) {
          audioId = window.location.href.split('fm/share/')[1].split('?')[0]
        }
        window.vipLock = new VipLock({
          audioId,
          isSelected: +window.baseInfo.isSelected,
          userVip: +window.baseInfo.userVip,
          isExchange: +window.baseInfo.isExchange,
          callback() {
            window.baseInfo.isExchange = 1
            window.location.reload()
          }
        })
      }
      // icon播放 暂停
      var playIconObj = document.getElementsByClassName('playIcon')[0]
      var animationDivObj = document.getElementsByClassName('animation-div')[0]
      playIconObj.addEventListener('click', function() {
        // 神策埋点-节目详情页-点击操作按钮
        track.trackEvent('m_FM_detail_clickoperationbutton', {
          button_name: '播放节目',
          fm_id: fm_id
        })
        if (+window.baseInfo.isSelected && !+window.baseInfo.isExchange) {
          return window.vipLock.showVipLock()
        } else if (that.data.playStatus) {
          $('.playIcon').css('display', 'none')
          $('.animation-div').css('display', 'block')
          window.play(true)
        } else {
          var toastDivObj = document.getElementsByClassName('toast-wrap')[0]
          var toastObj = document.getElementsByClassName('toast')[0]
          var playIconObj = document.getElementsByClassName('playIcon')[0]
          var animationDivObj = document.getElementsByClassName(
            'animation-div'
          )[0]
          animationDivObj.style.display = 'none'
          playIconObj.style.display = 'block'
          toastDivObj.style.display = 'flex'
          var noneTimer = setTimeout(function() {
            that.data.playStatus = false
            toastDivObj.style.display = 'none'
            clearTimeout(noneTimer)
          }, 1000)
        }
      })
      animationDivObj.addEventListener('click', function() {
        animationDivObj.style.display = 'none'
        playIconObj.style.display = 'block'
        window.play(false)
      })
    }
  }
  eventInit() {
    this.headerEvent()
    this.zhugeEvent()
    this.audioEvent()
  }
}

new programShare()



// WEBPACK FOOTER //
// ./src/pages/fm/programShare/index.js